import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ProductsGrid from './ProductsGrid.tsx';
import HeaderRes from './HeaderRes.tsx';

export default function MainGrid() {
  const [searchTerm, setSearchTerm] = React.useState<string>('');
  const [filters, setFilters] = React.useState({
    grupo: '',
    subgrupo: '',
    divisao: '',
  });

  const handleSearch = (termo : string) => {
    setSearchTerm(termo);
  };

  const handleFilterChange = (newFilters: { grupo?: string; subgrupo?: string; divisao?: string;}) => {
    { setFilters(prev => ({ ...prev, ...newFilters }))};
  }

  return (
      <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '1700px', } }}>
        <HeaderRes onSearch={handleSearch} onFilterChange={handleFilterChange} currentFilters={filters} />
        <Box display="flex" alignItems="center" sx={{ mb: 2, ml: 2, mt: 2 }}> 
          <Typography component="h1" variant="h6"> Produtos:</Typography>
        </Box>
        <Box>
          <ProductsGrid 
            searchTerm={searchTerm} 
            grupoFilter={filters.grupo} 
            subgrupoFilter={filters.subgrupo} 
            divisaoFilter={filters.divisao} 
          />
        </Box>
      </Box>
    );
  } 